/* Franchise / branding constants — single source of truth.
 * If you ever spin up a settings UI to edit these, override these defaults
 * from there. */
export const FRANCHISE_NAME = "SERVPRO of Wright County";
export const FRANCHISE_SHORT = "SERVPRO of Wright Co.";
export const APP_NAME = "Beyond Restoration";
export const APP_TAGLINE = "Restoration workflow platform";
